<template>
    <div>
      <div class="row">
        <div class="col-12">
          <page-header
            :page="page"
            @onReturn="() => $router.back()"
            :has-return="true"
         />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <filter-manager
            :display-advanced="false"
            class="search-bar"
            items-container-class="flex-wrap"
            search-icon="fa fa-sync"
            search-text="Procesar"
            search-container-class="btn-process"
            v-model="model.search.filters"
            :filters="filterManagerConfig"
            @search="onHandlerSearch"
            ref="filterRef"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import PageHeader from 'PageHeader'
  import FilterManager from 'FilterManager'
  import ReportServices from '@/modules/report/api'
  import DocumentServices from '@//modules/report/document'
  import LocationServices from '@/services/api/location.api';
  import code from '@/services/api/code.api'
  export default {
    components: {
      PageHeader,
      FilterManager,
    },
    data: () => 
    ({
      page: {
        icon: "fas fa-clipboard-list-check",
        title: "Detalle SAEE10",
        routes: ["Informes", "Detalle SAEE10"]
      },
      model: {
          search: {
          collections: {
            academicYears: [],
            centers: [],
            municipalities: [],
            schoolType: [],
            schools:[]
          },
          filters: {
            academicYear: null,
            center: null,
            municipality: null,
            schoolType: null,
            school: null,
            sie:null
          },
        },
      },
    }),
    computed: {
      filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: "Favor seleccionar un año académico.",
          validations: "required",
          class: 'col-md-4',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CSEE',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          disabled: this.model.search.filters.centerDisabled,
          onChanged: this.getMunicipalities,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Municipios',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.municipalities,
          value: this.model.search.filters.municipalitie,
          disabled: this.model.search.filters.municipality,
          onChanged: this.getSchools
        },
        {
          name: 'schoolType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Escuela',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.schoolType,
          value: this.model.search.filters.schoolType,
          onChanged: this.getSchools
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Escuela',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.schools,
          value: this.model.search.filters.school
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          icon: 'fa fa-search orange-icon',
          class: "col-md-4",
          leftIcon: true,
          maskType: 'SIE',
          value: this.model.search.filters.sie,
        },
      ]},
    },
    async mounted() {
        this.initFilters();
    },
    methods: {
      async initFilters(){
        await code.getSaee10FiltersAsync().then(({data}) => {
          this.model.search.collections.academicYears = data.academicYears;
          this.model.search.collections.centers = data.centers;
          this.model.search.collections.schoolType = data.schoolType
       });
       this.model.search.filters.academicYear = this.model.search.collections.academicYears[0]
      },
      async onHandlerSearch() {
        const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
        if (isValid) {
          this.process();
        }
      },
      async getSchools() {
        await LocationServices.getSchools({
          academicYearId: this.model.search.filters.academicYear.id,
          municipalityId: this.model.search.filters.municipality?.id,
          centerId: this.model.search.filters.center?.id,
          schoolTypes:this.model.search.filters.schoolType?.id
        }).then((res) => (this.model.search.collections.schools = res.data));
      },
      async getMunicipalities() {
        const { data } = await LocationServices.getMunicipalities({
            academicYearId: this.model.search.filters.academicYear.id,
            centerId: this.model.search.filters.center?.id,
        });
        this.model.search.collections.municipalities = data;
        this.getSchools();
      },
      async process() {
        const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

        if (!isValid) {
          this.ShowToast(
            'Alerta',
            'Favor completar la información solicitada.',
            'error'
          )
          return
        }
        await ReportServices.getReport('detailsaee10', {
          academicYearId: this.model.search.filters.academicYear.id,
          centerId: this.model.search.filters.center?.id,
          MunicipalityId:this.model.search.filters.municipality?.id,
          SchoolType: this.model.search.filters.schoolType?.id,
          SchoolId:this.model.search.filters.school?.id,
          Sie:this.model.search.filters.sie,
        })
        .then(res => DocumentServices.Download(res.data));
      },
    },
  }
  </script>